export const ELIGIBILITY_CHECK_TYPES = {
  FIELD_COMPARISON: "Field comparison (policy id, BIN etc.)",
  EMAIL: "E-mail (no verification)",
};
